/*
 * Copyright (c) 2021 Pegasystems Inc.
 * All rights reserved.
 */
import PubSubUtils from '../utils/pubsub-utils';

import { fetch, waitForUpdateSession } from './fetch';
import { getJWTServerDetails, isUpdateSessionRequest } from './utils';

export const reissueWebToken = (errorObj: any, fetchStatus: any, authInfo: any) => {
  const { config } = errorObj;
  const { url, config: configObj, callback, isRefreshTokenPresent } = getJWTServerDetails(authInfo);
  const context = config.headers && config.headers.context;
  if (config.data) {
    config.body = config.data;
  }

  const retryRequestPromise = waitForUpdateSession(config.url, config, context, fetchStatus);
  if (!isRefreshTokenPresent) {
    callback?.failure?.(config.url, authInfo);
    return retryRequestPromise;
  }

  return fetch(url, configObj)
    .then((resp: any) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // defer the communication of success to update session to next tick
          fetchStatus.setUpdateSessionStatus(false);
          fetchStatus.latestUpdateSessionTimeStamp = Date.now();
          callback?.success?.(resp, config);
          PubSubUtils.publish('updateSession', { updateStatus: 'success' });
          PubSubUtils.publish('OnUpdateSession', {});
          retryRequestPromise
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        }, 0);
      });
    })
    .catch((errorResponse: any) => {
      if (errorResponse && errorResponse.config && isUpdateSessionRequest(errorResponse.config.url, authInfo)) {
        callback?.failure?.(config.url, authInfo);
        return retryRequestPromise;
      }
      return Promise.reject(errorResponse);
    });
};

export default reissueWebToken;
